import { Icon, IconProps } from './Icon';

interface AiIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const AiIcon = ({ color = '#FEFEFE', gradient, ...props }: AiIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 25"
  >
    <defs>
      {gradient && (
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      )}
    </defs>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.99609 17.2937C5.20615 17.2937 6.99776 19.0853 6.99776 21.2953C6.99776 19.0853 8.78937 17.2937 10.9994 17.2937C8.78937 17.2937 6.99776 15.5021 6.99776 13.292C6.99776 15.5021 5.20615 17.2937 2.99609 17.2937Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 14.2927C15.2101 14.2927 17.0017 16.0843 17.0017 18.2943C17.0017 16.0843 18.7933 14.2927 21.0033 14.2927C18.7933 14.2927 17.0017 12.5011 17.0017 10.291C17.0017 12.5011 15.2101 14.2927 13 14.2927V14.2927Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99805 7.28975C9.20811 7.28975 10.9997 9.08136 10.9997 11.2914C10.9997 9.08136 12.7913 7.28975 15.0014 7.28975C12.7913 7.28975 10.9997 5.49815 10.9997 3.28809C10.9997 5.49815 9.20811 7.28975 6.99805 7.28975Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
